var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCautionTape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 77,
    viewBox: "0 0 1000 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2705 77H0L58.6503 3.05176e-05H92.9207L34.2705 77Z",
    fill: "#E3E0FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.861 77H75.5903L134.241 2.28882e-05H168.507L109.861 77Z",
    fill: "#E3E0FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185.447 77H151.18L209.83 2.28882e-05H244.097L185.447 77Z",
    fill: "#E3E0FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M261.038 77H226.771L285.421 2.28882e-05H319.688L261.038 77Z",
    fill: "#E3E0FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M336.628 77H302.361L361.012 2.28882e-05H395.278L336.628 77Z",
    fill: "#E3E0FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M412.219 77H377.952L436.602 3.05176e-05H470.869L412.219 77Z",
    fill: "#E3E0FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M487.808 77H453.542L512.192 2.28882e-05H546.459L487.808 77Z",
    fill: "#E3E0FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M563.399 77H529.132L587.782 2.28882e-05H622.049L563.399 77Z",
    fill: "#E3E0FB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M638.989 77H604.722L663.372 2.28882e-05H697.639L638.989 77Z",
    fill: "#E3E0FB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M714.579 77H680.312L738.963 2.28882e-05H773.23L714.579 77Z",
    fill: "#E3E0FB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M790.169 77H755.902L814.553 2.28882e-05H848.819L790.169 77Z",
    fill: "#E3E0FB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M865.76 77H831.489L890.143 1.52588e-05H924.41L865.76 77Z",
    fill: "#E3E0FB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M941.35 77H907.079L965.733 3.05176e-05H1000L941.35 77Z",
    fill: "#E3E0FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionTape);
export default __webpack_public_path__ + "static/media/cautionTape.a13fa09000f2c6662b8af25b237c9f60.svg";
export { ForwardRef as ReactComponent };